import { Modal, Tabs, Spin } from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import { useEffect, useState, useRef } from "react";
import AdminUser from "./AdminUser";
import AccessMenuHistory from "./AccessMenuHistory";
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND;

function AdminManage() {
  const dispatch = useDispatch();

  // 한 메뉴에 접근할 때 정보를 한꺼번에 불러와 하나의 상태로 저장한다.
  const [adminManageInfo, setAdminManageInfo] = useState({
    userAssignedMenuGroup: [],
    history: [],
  });
  const [menuGroupLists, setMenuGroupLists] = useState([])

  const resetUsers = () => {
    // console.log('이거 돌아가야돼')
    axios
      .get(`${backend}/admin_manage/admin_users`)
      .then(async (data) => {
        const {userAssignedMenuGroup, history, menuGroupList} = data.data.data
        // console.log(userAssignedMenuGroup) //최초 받은 내용

        userAssignedMenuGroup.forEach(ele => {
          const timeZone = 60 * 60 * 9 * 1000; // 9시간
          ele.create_datetime = new Date(+new Date(ele.create_datetime)+timeZone).toISOString().replace("T"," ").split(".")[0]
          ele.update_datetime = new Date(+new Date(ele.update_datetime)+timeZone).toISOString().replace("T"," ").split(".")[0]
        })

        setAdminManageInfo({userAssignedMenuGroup, history});
        setMenuGroupLists(menuGroupList)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          Modal.error({
            title: "로그인 인증 에러",
            content:
              "로그인 인증 만료기한이 경과하였습니다. 다시 로그인을 해주세요.",
            onOk: () => {
              dispatch(authAction(false, null));
            },
          });
        }
        console.log(err);
      });
  };
  // console.log("이거 돌아감",adminManageInfo)
  useEffect(() => {
    if (adminManageInfo.userAssignedMenuGroup.length === 0) resetUsers();
  });

  const items = [
    {
      label: "운영자",
      key: "item-1",
      style: {height:"100%"},
      children:
        adminManageInfo.userAssignedMenuGroup.length === 0 ? (
          <Spin>
            <AdminUser adminManageInfo={adminManageInfo} menuGroupLists={menuGroupLists} resetUsers={resetUsers}/>
          </Spin>
        ) : (
          <AdminUser adminManageInfo={adminManageInfo} menuGroupLists={menuGroupLists} resetUsers={resetUsers}/>
        ),
    }, // remember to pass the key prop
    {
      label: "메뉴접속 이력",
      key: "item-2",
      style: {height:"100%"},
      children:
        adminManageInfo.history.length === 0 ? (
          <Spin>
            <AccessMenuHistory adminManageInfo={adminManageInfo} menuGroupLists={menuGroupLists} resetUsers={resetUsers}/>
          </Spin>
        ) : (
          <AccessMenuHistory adminManageInfo={adminManageInfo} menuGroupLists={menuGroupLists} resetUsers={resetUsers}/>
        ),
    },
  ];

  return (
    <div style={{width:"100%",height:"100%"}}>
      <Tabs defaultActiveKey="item-1" type="card" size="middle" items={items} style={{width:"100%", height:"100%"}}/>
    </div>
  );
}

export default AdminManage;
